// Unidades de medida que se pueden elegir al pedir un producto o al revisar una cotización.
export const UNIDADES = ["Unidad", "Caja", "1/4", "Litro", "Galón", "Cubeta", "Metro", "Metro Cúbico (m³)"];
